module.exports = __webpack_public_path__ + "img/elo.375aec0e.svg";